module.exports = __webpack_public_path__ + "static/cauliflower-c1c8de5bb7ed082cb76c49111b8ce35c.svg";